import add from 'date-fns/add';
import format from 'date-fns/format';
import formatISO from 'date-fns/formatISO';
import formatRelative from 'date-fns/formatRelative';
import fromUnixTime from 'date-fns/fromUnixTime';
import parseISO from 'date-fns/parseISO'

import CronParser from 'cron-parser';

export const newFunction = () => {}

export const formatISOAsRelative = isoDate => formatRelative(parseISO(isoDate), new Date())

export const formatAssayDetailsDate = dateStr => format(parseISO(dateStr), 'MMM d yyyy')

export const formatAssayDetailsDatetime = dateStr => format(parseISO(dateStr), 'MMM d yyyy k:mm:ss')

export const formatOrchestrationRunDate = (dateStr) => {
  const parsedIso = parseISO(dateStr);
  const formattedDate = format(parsedIso, 'MMM d yyyy')
  const formattedTime = format(parsedIso, 'h:mm:ss aaa')

  return `${formattedDate} at ${formattedTime}`;
}

export const formatChartDate = labelFormatString => unixTimestamp => format(fromUnixTime(unixTimestamp), labelFormatString)

export const formatCSVDate = unixTimestamp => formatISO(fromUnixTime(unixTimestamp)).split('T').join(' ');

export const formatAssayPointDate = assayDate => formatISO(parseISO(assayDate));

export const formatChartPointDate = pointDate => format(parseISO(pointDate), 'LLL d k:mm:ss.SS')

export const getTimeRange = (selectedTimeRange = {}) => {
  const timeRangeType = selectedTimeRange?.type;
  if (timeRangeType === 'custom') {
    return [selectedTimeRange.fromDate, selectedTimeRange.toDate];
  }
  if (selectedTimeRange.duration) {
    return [add(new Date(), selectedTimeRange.duration), new Date()];
  }
  console.error('Unrecognized time range type', selectedTimeRange.type);
  return [add(new Date(), { hours: -1 }), new Date()];
}

export const getNextRunFromCronString = (cronSchedule = '') => {
  const parsedSchedule = CronParser.parseExpression(cronSchedule);
  return parsedSchedule.next().toISOString();
}
